import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AutomationPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/AutomationSuggestionsPicker/AutomationSuggestions/Content/AutomationPicker';
import { FDBodyText, FDBox, FDHeadlineText } from '@facet-wealth/design';
import ToolPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/AutomationSuggestionsPicker/AutomationSuggestions/Content/ToolPicker';
import { useAutomationSuggestionsContext } from '../Context';

const useStyles = buildUseStyles('AutomationSuggestion', (() => ({
  root: {
    overflowX: 'hidden',
  },
})));

const AutomationSuggestion = () => {
  const {
    automationSuggestionsCollection,
  } = useAutomationSuggestionsContext();

  const classes = useStyles();

  const resource = automationSuggestionsCollection.resources().head();
  return (
    <>
      <FDBox padding={2} className={classes.root}>
        <FDBox marginBottom={3} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <FDHeadlineText value={resource.attr('title')} />
        </FDBox>
      </FDBox>
      <FDBox padding={2} className={classes.root}>
        {resource.attr('automations').resources().list().length <= 0 && (
          <FDBodyText value={'No suggestions'} />
        )
          }
        {resource.attr('automations').resources().list().map((automationVariantResource) => {
          return (
            <AutomationPicker automationResource={automationVariantResource} />
          );
        })}
      </FDBox>
      <FDBox padding={2} className={classes.root}>
        <FDBox marginBottom={3} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <FDHeadlineText value={resource.attr('secondaryTitle')} />
        </FDBox>
      </FDBox>
      <FDBox padding={2} className={classes.root}>
        {resource.attr('tools').resources().list().length <= 0 && (
          <FDBodyText value={'No tools'} />
        )
        }
        {resource.attr('tools').resources().list().map((toolsResource) => {
          return (
            <ToolPicker toolResource={toolsResource} />
          );
        })}
      </FDBox>
    </>
  );
};

export default AutomationSuggestion;
